import DatePickerGeneric from "@components/DatePickerGeneric/DatePickerGeneric";
import { AlertDeliveryDateIcon, CheckGreenIcon } from "@components/Icons";
import { ModalGeneral } from "@components/ModalGeneral/ModalGeneral";
import { useIoCContext } from "@context/IoCContext/IoCContext";
import { useUserState } from "@context/UserContext";
import useDialogAlert from "@hooks/useDialogAlert";
import { Types } from "@ioc/types";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
  createStyles,
  makeStyles,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";

import { IQueryOrderDataDTO } from "@modules/orders/dtos/IQueryOrderDataDTO";
import { IQueryOrdersDTO } from "@modules/orders/dtos/IQueryOrdersDTO";
import {
  DownloadNfeQuery,
  DownloadType,
} from "@modules/orders/models/DownloadNfeQuery";
import { ICreatePDFOrdersService } from "@modules/orders/models/ICreatePDFOrdersService";
import { IDownloadByLineService } from "@modules/orders/models/IDownlodByLine";
import { IUpdateOrderService } from "@modules/orders/models/IUpdateOrderService";
import { ITEMS_PER_PAGE } from "@pages/User/MyOrders";

import FormQueryValidationSchema from "@pages/User/MyOrders/FormQueryValidationSchema";
import AppError from "@utils/AppError";
import { DownloadPDF, downloadThisWindow } from "@utils/MyOrders/download";
import { getValuesFilters } from "@utils/localStorageUtils";
import { format } from "date-fns";
import { useFlags } from "flagsmith/react";
import { useFormikContext } from "formik";
import React, { useState } from "react";
import { useFormQuery } from "./FormQueryContext";
import { ModalCancelOrder } from "./ModalCancelOrder";
import ModalTableOrders from "./Sections/ModalTableOrders";
import { IQuery } from "./interface";
import { ITableOrder, ITableOrderTitles } from "./models/ITableOrderTitles";

import { useRowSectionToggle } from "./hook/useRowMenuToggle";

import TableRowData from "./TableRowData";

interface ITableOrdersProps {
  page: number;
}

enum TypePaymentEnum {
  B = "À Prazo",
  T = "À vista",
}

const TableOrders: React.FC<ITableOrdersProps> = (props) => {
  const { snackbar } = useDialogAlert();
  const valuesFiltersStorage = getValuesFilters("valuesFilters");
  const filtersStorageObject = valuesFiltersStorage
    ? JSON.parse(valuesFiltersStorage ? valuesFiltersStorage : "")
    : "";
  const userState = useUserState();
  const classes = useStylesTableOrders();
  const formQueryContext = useFormQuery();
  const iocContext = useIoCContext();
  const createPDFOrdersService = iocContext.serviceContainer.get<
    ICreatePDFOrdersService
  >(Types.Orders.ICreatePDFOrdersService);
  const { values } = useFormikContext<IQuery>();
  const [orderToCancel, setOrderToCancel] = useState<IQueryOrderDataDTO | null>(
    null
  );
  const [openModal, setOpenModal] = useState(false);
  const [loadPDF, setLoadPDF] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);

  const [rowLoading, setRowLoading] = useState<boolean[]>(
    Array(formQueryContext.dataQuery.length).fill(false)
  );

  const downloadByService = iocContext.serviceContainer.get<
    IDownloadByLineService
  >(Types.Orders.IDownloadByLineService);

  const updateOrder = iocContext.serviceContainer.get<IUpdateOrderService>(
    Types.Orders.IUpdateOrderService
  );

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.only("xs"));

  const [modalDeliveryCalendar, setModalDeliveryCalendar] = useState<boolean>(
    false
  );
  const [modalSucessDelivery, setModalSucessDelivery] = useState<boolean>(
    false
  );
  const [modalErrorDelivery, setModalErrorDelivery] = useState<boolean>(false);
  const [deliveryDate, setDeliveryDate] = useState<Date | null>(null);

  const [numberOrderByLine, setNumberOrderByLine] = useState("");
  const [, setFreightTypeByLine] = useState("");

  const [indexClicked, setIndexClicked] = useState<number>(0);
  const [openDialog, setOpenDialog] = useState(false);

  const today = new Date();
  let minDateAllowed = today;

  const [selectedDate, setSelectedDate] = useState(deliveryDate || today);

  const featureFlagDeliveryDate = useFlags(["your_orders_update_delivery_date"])
    .your_orders_update_delivery_date.enabled;

  const handleOpenDeliveryCalendar = () => {
    setModalDeliveryCalendar(true);
  };

  const handleCloseDeliveryCalendar = () => {
    setModalDeliveryCalendar(false);
  };

  const handleCloseModalSuccessDelivery = () => {
    setModalSucessDelivery(false);
  };

  const handleCloseModalErrorDelivery = () => {
    setModalErrorDelivery(false);
  };
  const handleUpdateDeliveryDate = async () => {
    try {
      setIsLoading(true);
      const formattedDate = selectedDate
        ? format(selectedDate, "yyyy-MM-dd")
        : "";

      await updateOrder.execute({
        orderId: numberOrderByLine,
        requestedDeliveryDate: formattedDate,
      });

      setModalSucessDelivery(true);
    } catch (error) {
      setModalErrorDelivery(true);
    } finally {
      setIsLoading(false);
    }
  };

  const getColumnsOrder = (): ITableOrder[] => {
    const CALENDAR_COL = "calendarUpdateDelivery";
    const CANCEL_COL = "cancelOrder";

    let columnsTable: ITableOrder[] = ITableOrderTitles;
    columnsTable = columnsTable.filter((column) => column.id !== CANCEL_COL);

    // Ocultar o título de alterar data entrega se a feature flag estiver desativada
    if (!featureFlagDeliveryDate) {
      columnsTable = columnsTable.filter((c) => c.id !== CALENDAR_COL);
    }

    return columnsTable;
  };

  const columnsOrderMocked: ITableOrder[] = getColumnsOrder();

  const fetchDownload = async (query: DownloadNfeQuery) => {
    try {
      const response = await downloadByService.execute(query);
      switch (query.type) {
        case "pdf":
          downloadThisWindow(response, "pdf", query);
          break;
      }
    } catch (error) {
      snackbar({
        message: "Erro ao tentar baixar Nota Fiscal !",
        variant: "error",
      });
    }
  };

  const downloadByLineTable = async (
    type: DownloadType,
    nfKey?: string,
    rowIndex?: number
  ) => {
    if (!nfKey || rowIndex === undefined) return;

    try {
      setRowLoading((prevLoading) => {
        const newLoading = [...prevLoading];
        if (rowIndex >= 0) newLoading[rowIndex] = true;
        return newLoading;
      });

      switch (type) {
        case "pdf":
          await fetchDownload({
            type,
            codes: [nfKey],
          });
          break;
        default:
          break;
      }
    } catch (error) {
      snackbar({
        message: "Erro ao tentar baixar Nota Fiscal !",
        variant: "error",
      });
    } finally {
      setRowLoading((prevLoading) => {
        const newLoading = [...prevLoading];
        if (rowIndex >= 0) newLoading[rowIndex] = false;
        return newLoading;
      });
    }
  };

  const handleDownloadExcel = async () => {
    try {
      setLoadPDF(true);
      if (values.startDate && values.endDate) {
        const casted = FormQueryValidationSchema.cast(values);
        if (userState.listCNPJ[0]) {
          let CNPJ = [`${userState.listCNPJ[0].CNPJ}`];
          if ((casted?.CNPJ as string[]).length !== 0) {
            CNPJ = casted?.CNPJ as string[];
          }
          const queryOrdersPDF: IQueryOrdersDTO = {
            companies: filtersStorageObject.CNPJ
              ? filtersStorageObject.CNPJ
              : CNPJ,
            beginDate: filtersStorageObject.dateRange[0]
              ? filtersStorageObject.dateRange[0]
              : casted?.dateRange[0],
            endDate: filtersStorageObject.dateRange[1]
              ? filtersStorageObject.dateRange[1]
              : casted?.dateRange[1],
            filterBy: "deliveryDate",
            statusPortalCliente: filtersStorageObject.statusSale
              ? filtersStorageObject.statusSale
              : casted?.statusSale,
            page: props.page > 1 ? props.page : 1,
            limit: ITEMS_PER_PAGE,
            type: "v2",
          };

          const urlFile = await createPDFOrdersService.searchExcel(
            queryOrdersPDF
          );
          DownloadPDF(urlFile, "relatorio-dos-pedidos");
        } else {
          throw new Error("Nao possui CNPJ para realizar a consulta");
        }
      }
    } catch (error) {
      if (error instanceof AppError) {
        snackbar({
          message: `Ocorreu um erro ao buscar relatorio ! ${error.message}`,
          variant: "error",
        });
      }
    } finally {
      setLoadPDF(false);
    }
  };

  const isButtonDisabled = () => {
    return (
      !selectedDate ||
      (deliveryDate &&
        selectedDate.toISOString() === deliveryDate.toISOString()) ||
      undefined
    );
  };

  function getPaymentType(paycond: number): string {
    if (paycond === 0) {
      return TypePaymentEnum.T;
    }

    const quantityDay = paycond === 1 ? "Dia" : "Dias";

    return `${paycond.toString()} ${quantityDay}` || "";
  }

  const { isOpen, select } = useRowSectionToggle();

  return (
    <Box className={classes.paperTable}>
      {loadPDF ? (
        <CircularProgress
          color="primary"
          style={{
            marginLeft: "10px",
            height: "2.0rem",
            width: "2.0rem",
          }}
        />
      ) : (
        <Button
          className={classes.buttonDownloadReport}
          color="primary"
          onClick={() => handleDownloadExcel()}
        >
          Baixar relatório completo
        </Button>
      )}

      <Grid container justify="center"></Grid>
      <TableContainer className={classes.TableContainer}>
        <Table
          className={classes.Table}
          stickyHeader
          style={{ borderSpacing: isMobile ? "0px 13px" : "0px 20px" }}
        >
          <TableHead>
            <TableRow className={classes.TableRow}>
              {columnsOrderMocked
                .filter((col) =>
                  isMobile ? col.show.mobile : col.show.desktop
                )
                .map((col) => (
                  <TableCell
                    key={col.id}
                    align={col.align}
                    className={classes.TableCellHead}
                    style={{ fontSize: isMobile ? "1.3rem" : undefined }}
                  >
                    {col.option}
                  </TableCell>
                ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {formQueryContext.dataQuery.map((ele, index) => {
              return (
                <TableRowData
                  key={ele.numberOrder}
                  ele={ele}
                  index={index}
                  isMobile={isMobile}
                  rowLoading={rowLoading}
                  downloadByLineTable={downloadByLineTable}
                  getPaymentType={getPaymentType}
                  select={select}
                  isOpen={isOpen}
                  featureFlagDeliveryDate={featureFlagDeliveryDate}
                  handleOpenDeliveryCalendar={handleOpenDeliveryCalendar}
                  setFreightTypeByLine={setFreightTypeByLine}
                  setNumberOrderByLine={setNumberOrderByLine}
                  setDeliveryDate={setDeliveryDate}
                  setOrderToCancel={setOrderToCancel}
                  setOpenModal={setOpenModal}
                  setIndexClicked={setIndexClicked}
                  setOpenDialog={setOpenDialog}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <ModalTableOrders
        open={openDialog}
        dataOrder={(formQueryContext.dataQuery || [])[indexClicked]}
        handleOnClose={() => setOpenDialog(false)}
      />

      {orderToCancel ? (
        <ModalCancelOrder
          open={openModal}
          orderData={orderToCancel}
          closeModal={() => {
            setOrderToCancel(null);
            setOpenModal(false);
          }}
        />
      ) : (
        <></>
      )}

      {modalDeliveryCalendar && (
        <ModalGeneral
          open={modalDeliveryCalendar}
          closeModal={handleCloseDeliveryCalendar}
          titleHeaderModal={"Alterar data da entrega"}
          resetPadding={true}
          width={isMobile ? "100%" : "500px"}
          height={isMobile ? "420px" : "580px"}
          labelButtonCancel={"Cancelar"}
          labelButtonSubmit={"Alterar data"}
          onClickSubmit={handleUpdateDeliveryDate}
          hasDialogActions={true}
          isDisabledSubmitted={isButtonDisabled()}
          isLoading={isLoading}
        >
          <Grid item xs={12}>
            <Typography
              className={classes.DescriptionChangeDeliveryCalendar}
              style={{
                fontSize: isMobile ? "1.2rem" : "1.6rem",
              }}
            >
              Selecione a nova data de entrega.
            </Typography>
          </Grid>
          <Grid
            container
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <DatePickerGeneric
              minDate={minDateAllowed}
              dateSelected={deliveryDate}
              onDateChange={(newDate) => setSelectedDate(newDate)}
              disableSundays={true}
            />
          </Grid>
        </ModalGeneral>
      )}

      {modalSucessDelivery && (
        <ModalGeneral
          open={modalSucessDelivery}
          closeModal={handleCloseModalSuccessDelivery}
          title={"Data de entrega alterada com sucesso."}
          icon={<CheckGreenIcon style={{ width: "80px", height: "80px" }} />}
          width={isMobile ? "100%" : "500px"}
          height={isMobile ? "320px" : "400px"}
          hasDialogActions={false}
          resetPadding={false}
        >
          <Typography className={classes.DescriptionSucessDelivery}>
            Você alterou a data de entrega do pedido{" "}
            <span className={classes.SpanSubTitleDelivery}>
              {numberOrderByLine}
            </span>{" "}
            para
            <span className={classes.SpanSubTitleDelivery}>
              {selectedDate
                ? format(selectedDate, "dd/MM/yyyy")
                : "data não definida"}
            </span>
          </Typography>
        </ModalGeneral>
      )}

      {modalErrorDelivery && (
        <ModalGeneral
          open={modalErrorDelivery}
          closeModal={handleCloseModalErrorDelivery}
          title={"Ocoreu um erro ao tentar alterar data de agendamento"}
          icon={
            <AlertDeliveryDateIcon style={{ width: "80px", height: "80px" }} />
          }
          width={isMobile ? "100%" : "500px"}
          height={isMobile ? "360px" : "400px"}
        >
          <Typography className={classes.DescriptionSucessDelivery}>
            Tente novamente!
          </Typography>
        </ModalGeneral>
      )}
    </Box>
  );
};
export const useStylesTableOrders = makeStyles((theme: Theme) =>
  createStyles({
    DescriptionChangeDeliveryCalendar: {
      fontFamily: "Montserrat",
      color: "#3E3D3D",
      textAlign: "center",
      opacity: "0.3",
    },
    DescriptionPermittedTimeDelivery: {
      fontSize: "1.4rem",
      paddingTop: "10px",
      fontFamily: "Montserrat",
      color: "#3E3D3D",
      textAlign: "center",
      fontWeight: "bold",
    },
    SpanSubTitleDelivery: {
      color: "#D91F05",
      fontWeight: "bold",
    },
    DescriptionSucessDelivery: {
      fontSize: "1.6rem",
      paddingTop: "10px",
      fontFamily: "Montserrat",
      color: "#3E3D3D",
      textAlign: "center",
      [theme.breakpoints.only("xs")]: {
        fontSize: "1.3rem",
      },
    },
    TitleOrder: {
      color: "#3E3D3D",
      fontWeight: "bold",
      fontFamily: "Montserrat",
      fontSize: "3rem",
      paddingBottom: "20px",
    },
    TableContainer: {
      width: "100%",
      boxShadow: "none",
    },
    Table: {
      borderCollapse: "separate",
    },
    TableRow: {
      background: "#fff",
    },
    TableCell: {
      padding: "6px 16px 6px 16px",
      marginBottom: "20px",
    },
    TableCellHead: {
      fontWeight: "bold",
      whiteSpace: "nowrap",
      fontFamily: "DM Sans",
      background: "#fff",
      "&:first-child": {
        paddingLeft: "2.5rem",
        borderBottomLeftRadius: "0.6rem",
        borderTopLeftRadius: "0.6rem",
      },
      "&:last-child": {
        borderBottomRightRadius: "0.6rem",
        borderTopRightRadius: "0.6rem",
      },
    },
    paperTable: {
      background: "#F5F5F5",
      overflowX: "scroll",

      "&::-webkit-scrollbar": {
        background: theme.palette.grey[300],
        height: "0.7rem",
        borderRadius: ".4rem",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.grey["900"],
        borderRadius: ".4rem",
      },
    },
    iconImg: {
      filter:
        "invert(45%) sepia(0%) saturate(1244%) hue-rotate(218deg) brightness(85%) contrast(92%);",
    },
    paperSituation: {
      padding: "0 1rem",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontWeight: "bold",
      fontFamily: "Montserrat",
    },
    paperSituationSuccess: {
      color: "#0BB873",
      fontWeight: "bold",
      fontFamily: "Montserrat",
    },
    paperSituationError: {
      color: "#F97A91",
      fontWeight: "bold",
      fontFamily: "Montserrat",
    },

    TableCellFromData: {
      background: "#fff",
      marginBottom: "10px",
      borderBottom: "none",
      fontFamily: "DM Sans",
      "&:first-child": {
        paddingLeft: "2.5rem",
        borderBottomLeftRadius: "0.6rem",
        borderTopLeftRadius: "0.6rem",
      },
      "&:last-child": {
        borderBottomRightRadius: "0.6rem",
        borderTopRightRadius: "0.6rem",
      },
    },
    buttonDownloadReport: {
      textTransform: "none",
      fontFamily: "Montserrat",
      fontWeight: 600,
      lineHeight: "2.875rem",
      height: "auto",
    },
  })
);

export default TableOrders;
